/**
 * FullScreenToggle — Shared toggle button for entering/exiting fullscreen mode.
 *
 * Used by all game components. Shows ⛶ to enter and ⛶ to exit.
 * Hidden if the Fullscreen API is not supported by the browser.
 */

import React from 'react';
import { useFullScreen } from '../hooks/useFullScreen';
import './FullScreenToggle.css';

interface FullScreenToggleProps {
  /** Optional className for positioning */
  className?: string;
}

export const FullScreenToggle: React.FC<FullScreenToggleProps> = ({ className }) => {
  const { isFullScreen, toggleFullScreen, isSupported } = useFullScreen();

  if (!isSupported) return null;

  return (
    <button
      className={`fullscreen-toggle ${isFullScreen ? 'fullscreen-toggle--active' : ''} ${className || ''}`}
      onClick={toggleFullScreen}
      aria-label={isFullScreen ? 'Exit full screen' : 'Enter full screen'}
      title={isFullScreen ? 'Exit Full Screen (Esc)' : 'Full Screen'}
    >
      {isFullScreen ? (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3" />
        </svg>
      ) : (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3" />
        </svg>
      )}
    </button>
  );
};

export default FullScreenToggle;
